/* eslint-disable @typescript-eslint/member-ordering */
import Timestamp = firebase.firestore.Timestamp;
import firebase from 'firebase/compat/app';


export interface ParticleTaskMap {
    [key: string]: ParticleTask;
}

export interface ParticleTask {
    taskDate: Timestamp;
    taskStatus: 'scheduled' | 'complete' | 'error';
    taskCreated?: Timestamp;
    noteKey?: string;
}

export interface ParticleNote {
    content: string;
    dateCreated: Timestamp;
    dateLastModified: Timestamp;
}

export interface FileMetadata {
    attachmentId: string;
    size: number;
    mimeType: string;
    filename: string;
    location: 'outlook' | 'gmail' | 'storage';
    isInline: boolean;
    contendId: string;
}
